import { gql } from '@apollo/client';
import { PEOPLE_PROFILE } from '../../fragments';

export const GET_PERSON = gql`
  query GetPerson($id: ID!) {
    person: getPerson(id: $id) {
      ...peopleProfile
    }
  }
  ${PEOPLE_PROFILE}
`;
